import { useChainId } from 'wagmi'
import useReadConfigManager from '../read/useConfigManagerRead'
import { useQuery } from '@tanstack/react-query'
import { ALL_PARAMETER_TYPES, ParameterType } from '@/types/governance/parameters'

export type ActiveProposalTypes = {[key in ParameterType]: boolean}

export default function useActiveProposalTypes() {
    const chainId = useChainId()
    const configManager = useReadConfigManager()

    const { data } = useQuery<ActiveProposalTypes>({
        queryKey: ['activeProposalTypes', chainId],
        queryFn: async () => {
            const promises = ALL_PARAMETER_TYPES.map((proposalType: number) => configManager.activeProposalParameterTypes([proposalType]))
            const activeStatuses = await Promise.all(promises)
            return ALL_PARAMETER_TYPES.reduce((statusMap, proposalType, index) => ({
                ...statusMap,
                [proposalType]: activeStatuses[index]
            }), {}) as ActiveProposalTypes
        }
    })

    return data
}